module.exports = __webpack_public_path__ + "files/2a61c95c6f5b36041a647d858a95d611.png";